var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mm_body" },
    [
      _c("mmheader", { attrs: { "mm-site-url": _vm.mm_site_url } }),
      _vm._v(" "),
      _c("div", { staticStyle: { clear: "both" } }),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "container",
          staticStyle: { "padding-top": "72px !important" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-center mb-3" }, [
            _c(
              "div",
              { staticClass: "col-md-5 col-11" },
              [_c("CreateAccountForm")],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("mmfooter", { attrs: { "mm-site-url": _vm.mm_site_url } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center text_bebas" }, [
      _c("div", { staticClass: "mt-5 mb-4 h3 font-weight-bold" }, [
        _vm._v("Get Started with Mentor Mentee")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37854461", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37854461","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/create_account/create.vue
// module id = null
// module chunks = 